export default __webpack_public_path__ + "static/media/gallery_18.30a3f82c.jpg";